/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/*  
    Product Images module. 
    This module reloads product images user makes selections.
*/

define('modules/Product/Product360Image',[
    'jquery',
    'global/all',
    'plugins/imagesloaded.pkgd.min',
    './Product360ViewService',
    'plugins/jquery.zoomswap'
], function ($, Roc, imagesLoaded, Product360ViewService) {
    'use strict';

    var packagePath = window.RocConfig.cms.packagePath;

    var selectors = {
        mainImageContainer: '.productImage',
        mainImage: '.productImage img.mainImage',
        enlargeViewMainImageContainer: '#enlarge-view-modal .roc-productImage-large',
        iframe360View: 'iframe[data-roc-action="product360View"]',
        productImageControls: '.product-image-controls',
        enlargeView: '#enlarge-view-modal'
    };

    function initImageEnlarge() {
        var imageControls = $(selectors.productImageControls);
        var imageContrainer = $(selectors.enlargeViewMainImageContainer);
        var initImageSrc = imageContrainer.data('rocSrc');
        var imageLarge = imageContrainer.find('img');

        if(imageLarge.length <= 0) {
            imageContrainer.append('<img src="' + initImageSrc + '" alt="" />');
        }

        imageControls.on('click', '#enlarge-view-button', function (e) {
            Roc.UI.Modal.open('#enlarge-view-modal');
        });
    };

    function initMainProductImage() {
        var $mainProductImage = $(selectors.mainImageContainer);
        var regularPath = $mainProductImage.data('zoomswapRpath');
        var largePath = $mainProductImage.data('zoomswapZpath');
        
        Roc.UI.siteBody
            .off('click', '.altViews li a')
            .on('click', '.altViews li a', function () {
                var newimg = $(this).attr('href');
                //update active status
                var altViews = $('.altViews li');
                altViews.each(function (i) {
                    var children = altViews.eq(i).children('a');
                    children.each(function (j) {
                        if (newimg.replace('/' + largePath + '/', '').replace('/' + regularPath + '/', '') === children.eq(j).attr('href').replace('/' + largePath + '/', '').replace('/' + regularPath + '/', '')) {
                            children.eq(j).addClass('active');
                        } else {
                            children.eq(j).removeClass('active');
                        }
                    });
                });

                var $mainImage = $(selectors.mainImage);
                var $enlargeViewMainImage = $(selectors.enlargeViewMainImageContainer + ' img');
                var $zoomInControl = $(selectors.productImageControls + ' .icon-zoom-in');
                var $zoomOutControl = $(selectors.productImageControls + ' .icon-zoom-out');
                var $iframe360View = $(selectors.iframe360View);

                $mainImage.attr({ src: newimg });
                $enlargeViewMainImage.attr({ src: newimg.replace('/' + regularPath + '/', '/' + largePath + '/') });

                // Customization: update img attributes for 360 view
                var action = $(this).attr('data-roc-action');
                if (action !== undefined && action === 'enable360View') {
                    // if user clicked 360 img thumbnail then hide zoom-in/out controls
                    $mainImage.hide();
                    $enlargeViewMainImage.hide();
                    $iframe360View.show();
                    $zoomInControl.addClass('hidden');
                    $zoomOutControl.addClass('hidden');
                } else {
                    // if user clicked a regular img then show image, hide 360 view (iframe) and show zoom-in/out controls
                    $mainImage.show();
                    $enlargeViewMainImage.show();
                    $iframe360View.hide();
                    $zoomInControl.removeClass('hidden');
                    $zoomOutControl.removeClass('hidden');
                }
                return false;
            });
        
            $('.zoom-swap').each(function () {
                var cont = $(this);
                var imageCont = cont.zoomSwap({
                    trigger: $('.product-image-controls .icon-zoom-in'),
                    reset: $('.product-image-controls .icon-refresh, .product-image-controls .icon-zoom-out'),
                    zoomMethod: 'hover',
                    zoomInverse: true,
                    rPath: regularPath,
                    zPath: largePath
                });
            });

            initImageEnlarge();
    };

    function initImagesLoaded() {
        var $productImages = $('.site-container .roc-image-product');
        var imgLoad = imagesLoaded($productImages);

        imgLoad.on('progress', function (instance, image) {
            var result = image.isLoaded ? 'loaded' : 'broken';
            if (result === 'broken') {
                Roc.Logger.warn('Image Broken: ' + image.img.src);

                var naImage = packagePath + '/assets/images/na-images/na-l.svg',
                    $brokenImage = $(image.img);

                if ($brokenImage.data('rocDimensionKey')) {
                    naImage = packagePath + '/assets/images/na-images/na-' + $brokenImage.data('rocDimensionKey') + '.svg';
                };

                // change broken image src with spacer.gif and apply broken image class
                $brokenImage.attr('data-roc-original-image', image.img.src);
                image.img.src = naImage;

                $brokenImage.addClass('roc-image-na');
            };
        });
    };

    function clearAltImages() {
        $('ul.altViews').empty();
        $(selectors.enlargeView).find('.altViews').empty();
    }

    function updateMainImage(imagePath) {
        $(selectors.mainImage).attr('src', imagePath);
        $(selectors.enlargeViewMainImageContainer + ' img').attr({ src: imagePath });
    }

    function createAltView(image, is360AltView) {
        var altViewAnchor = document.createElement('a');
        altViewAnchor.setAttribute('href', Roc.Core.getImageUrl(image, 458, 458));

        if (is360AltView) {
            altViewAnchor.setAttribute('data-roc-action', 'enable360View');
        }

        var altViewImg = document.createElement('img');
        altViewImg.setAttribute('src', Roc.Core.getImageUrl(image, 60, 60));
        altViewImg.setAttribute('style', 'width: 60px; height: 60px;');
        altViewImg.setAttribute('class', 'roc-image-product');
        altViewAnchor.appendChild(altViewImg);

        var listItem = document.createElement('li');
        listItem.appendChild(altViewAnchor);
        return listItem;
    }

    function create360ViewIframe(productId, width, height, hidden) {
        var iframe = document.createElement('iframe');
        var iframeStyle = 'border: 0px; max-width: 100%; max-height: 100%;';
        if (hidden) {
            iframeStyle += 'display: none;'
        }

        iframe.setAttribute('style', iframeStyle);
        iframe.setAttribute('marginheight', 0);
        iframe.setAttribute('marginwidth', 0);
        iframe.setAttribute('scrolling', 'no');
        iframe.setAttribute('src', '/product360View.aspx?productId=' + productId + '&width=' + width + '&height=' + height);
        iframe.setAttribute('width', width);
        iframe.setAttribute('height', height);
        iframe.setAttribute('data-roc-action', 'product360View');

        var iframeParagraph = document.createElement('p');
        iframeParagraph.innerHTML = 'Your browser does not support iframes.';
        iframe.appendChild(iframeParagraph);

        return iframe;
    }

    var images360Promise = null;
    function get360Images(viewModel) {
        if (images360Promise !== null) {
            images360Promise.abort();
        }

        var hasRegularImages = viewModel !== undefined &&
            viewModel !== null &&
            viewModel.images !== undefined &&
            viewModel.images !== null &&
            viewModel.images.length > 0;

        var mainImageContainer = $(selectors.mainImageContainer);
        var enlargeModal = document.getElementById("enlarge-view-modal");
        var $zoomInControl = $(selectors.productImageControls + ' .icon-zoom-in');
        var $zoomOutControl = $(selectors.productImageControls + ' .icon-zoom-out');

        images360Promise = Product360ViewService.get360Images(viewModel.id);
        images360Promise.done(function (response) {
            // first remove existing 360 iframe(s) and show main image (in enlarge view too)
            $(selectors.iframe360View).remove();
            $(selectors.mainImage).show();
            $(selectors.enlargeViewMainImageContainer + ' img').show();
            $zoomInControl.removeClass('hidden');
            $zoomOutControl.removeClass('hidden');

            if (!response || !response.images360 || response.images360.length === 0 || !response.thumbnail) {
                if (hasRegularImages) {
                    return;
                }
                // display N/A img because there are no regular images and no 360 images
                updateMainImage(packagePath + '/assets/images/na-images/na-l.svg');
                return;
            }

            // otherwise display 360 images
            var altViews = document.getElementsByClassName('altViews');
            
            var altViewsModal = enlargeModal !== null
                ? enlargeModal.getElementsByClassName("altViews")
                : null;

            var altView = createAltView({ 'asset': response.thumbnail }, true);
            altViews[0].appendChild(altView);

            if (altViewsModal && altViewsModal.length > 0) {
                var altViewModal = altView.cloneNode(true);
                altViewsModal[0].appendChild(altViewModal);
            }

            var mainImageContainer = $(selectors.mainImageContainer);
            if (mainImageContainer && mainImageContainer.length > 0) {
                var iframe = create360ViewIframe(viewModel.id, 458, 458, hasRegularImages);
                mainImageContainer.append(iframe);
                if (!hasRegularImages) {
                    $(selectors.mainImage).hide(); // if there are no regular images then hide main image (iframe would be displayed by default)
                    $zoomInControl.addClass('hidden');
                    $zoomOutControl.addClass('hidden');
                }
            }

            var enlargeViewMainImageContainer = $(selectors.enlargeViewMainImageContainer);
            if (enlargeViewMainImageContainer.length > 0) {
                var enlargeIframe = create360ViewIframe(viewModel.id, 590, 590, hasRegularImages);
                enlargeViewMainImageContainer.append(enlargeIframe);
                if (!hasRegularImages) {
                    $(selectors.enlargeViewMainImageContainer + ' img').hide(); // // if there are no regular images then hide main image in the enlarge view (iframe would be displayed by default)
                }
            }
        }).fail(function (xhr) {
            // this callback is fired also when the original request was aborted
            // below condition is to check if it was aborted
            if (!xhr.getAllResponseHeaders()) {
                return; // request was just aborted
            }
            
            $(selectors.iframe360View).remove();
            $(selectors.mainImage).show();
            $(selectors.enlargeViewMainImageContainer + ' img').show();
            // if there are no regular images then display N/A placeholder otherwise nothing because regular images are already displayed
            if (!hasRegularImages) {
                updateMainImage(packagePath + '/assets/images/na-images/na-l.svg');
            }
        });
    }

    function reloadProductImages(viewModel) {
        if (!viewModel) {
            return;
        }

        clearAltImages();

        if (!viewModel || !viewModel.images || (viewModel.images && viewModel.images.length === 0)) {
            // there are no regular images so get 360 images only
            get360Images(viewModel);
            return;
        }

        if (viewModel.images && viewModel.images.length === 0) {
            updateMainImage(packagePath + '/assets/images/na-images/na-l.svg');
            return;
        }

        updateMainImage(Roc.Core.getImageUrl(viewModel.images[0], 458, 458));

        var altViews = document.getElementsByClassName('altViews');
        var enlargeModal = document.getElementById("enlarge-view-modal");
        var altViewsModal = enlargeModal !== null
            ? enlargeModal.getElementsByClassName("altViews") 
            : null;

        for (var i = 0; i < viewModel.images.length; i++) {
            var altView = createAltView(viewModel.images[i], false);
            altViews[0].appendChild(altView);

            if (altViewsModal && altViewsModal.length > 0) {
                var altViewModal = altView.cloneNode(true);
                altViewsModal[0].appendChild(altViewModal);
            }
        }

        // once regular images are displayed then get 360 images
        get360Images(viewModel);
    }

    function init() {
        initMainProductImage();
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductImages);
    }

    var ProductImage = {
        init: init,
        initImagesLoaded: initImagesLoaded,
        initMainProductImage: initMainProductImage
    }

    Roc.Logger.debug('ProductImage.js Loaded:', ProductImage);

    return ProductImage;
});
